import React from 'react';
import { Stack, Typography } from '@mui/material';
import BlurPrice from './BlurPrice';
import { formatAmount } from '../../utils/format-amout';

/**
 * Shows net booking total; when discounted, original (sub_total) is struck through.
 * Amounts must come from booking columns — not booking_discount_usages.
 */
export default function BookingPriceDisplay({ subTotal, netTotal, align = 'right' }) {
    const original = Number(subTotal) || 0;
    const net = Number(netTotal) || 0;
    const showStrike = original > net && net >= 0;

    const content = showStrike ? (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent={align === 'right' ? 'flex-end' : 'flex-start'}>
            <Typography
                component="span"
                sx={{ fontWeight: 700, textDecoration: 'line-through', color: '#fe0000ff' }}
            >
                {formatAmount(original, false)}
            </Typography>
            <Typography component="span" sx={{ fontWeight: 700 }}>
                {formatAmount(net, false)}
            </Typography>
        </Stack>
    ) : (
        <Typography component="span" sx={{ fontWeight: 700 }}>
            {formatAmount(net, false)}
        </Typography>
    );

    return <BlurPrice>{content}</BlurPrice>;
}
